<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="main">
      <b-row>
        <b-col cols="8">
          <div class="inner__style">
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">اطلاعات محصول</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="mb-3">
                  <BaseText
                    :required="true"
                    :showError="productIdError"
                    errortext="وارد کردن کد محصول اجباری است"
                    @input="productId = $event"
                    :value="productId"
                    title="کد محصول"
                    placeholder="کد محصول"
                  />
                </div>
                <div class="mb-3">
                  <BaseText
                    :required="true"
                    :showError="productTitleError"
                    errortext="وارد کردن عنوان محصول الزامی است"
                    @input="productTitle = $event"
                    :value="productTitle"
                    title="عنوان محصول"
                    placeholder="عنوان محصول"
                  />
                </div>
                <div>
                  <Price
                    @input="productPrice = $event"
                    :value="productPrice"
                    :required="true"
                    :showError="productPriceError"
                    errortext="وارد کردن قیمت الزامی است"
                    title="قیمت  (تومان) "
                    placeholder="قیمت  (تومان) "
                  />
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">تنوع محصول</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <b-row class="mb-3" v-for="(property, index) in properties" :key="property">
                  <b-col :cols="properties.length > 1 ? '4' : '6'">
                    <BaseText
                      :value="propertykeys[index]"
                      @enterButton="addNewPropertyField(index)"
                      @input="propertykeys[index] = $event"
                      title="عنوان صفت"
                      placeholder="عنوان صفت"
                    />
                  </b-col>
                  <b-col :cols="properties.length > 1 ? '7' : '6'">
                    <BaseText :value="propertyValues[index]" @input="propertyValues[index] = $event" title="صفت" placeholder="صفت" />
                  </b-col>
                  <b-col :cols="properties.length > 1 ? '1' : '0'">
                    <div v-if="properties.length > 1" @click="removePropertyField(index)" class="remove-field-link">
                      <i class="far fa-times-circle"></i>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">یادداشت</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="">
                  <TextAreaInput :value="productNote" @input="productNote = $event" title="یادداشت" placeholder="یادداشت" />
                </div>
              </div>
            </div>
            <b-row class="mb-3">
              <b-col class="deactiveUser" lg="4">
                <input type="checkbox" id="checkbox-productIsActive" v-model="productIsActive" name="checkbox-productIsActive" />
                <span for="checkbox-productIsActive" class="checkbox-margin">نمایش محصول</span>
              </b-col>
              <b-col lg="8">
                <div class="buttonClass">
                  <div @click="submit">
                    <Button btnClass="submitButton" text="ثبت" :loading="disableSubmit" />
                  </div>
                  <b-button @click="$bvModal.show('cancleModal')" class="cancleButton">
                    <span class="cancleTitle">انصراف</span>
                  </b-button>
                  <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
                    <div class="error-wrapper">
                      <div class="mb-4">
                        <img src="@/assets/images/checked1.svg" />
                      </div>
                      <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
                      <div class="buttons">
                        <button @click.native="$bvModal.hide('cancleModal')" class="cancelButton">خیر</button>
                        <button @click.native="cancelButton" class="approveButton">بلی</button>
                      </div>
                    </div>
                  </b-modal>
                </div>
              </b-col>
            </b-row>
            <Toast title="لطفا اطلاعات کالا را کامل کنید" :error="true" :showToast="showErrorToast" />
            <Toast title="لطفا برای کالای خود عکس انتخاب کنید" :error="true" :showToast="showImageToast" />
          </div>
        </b-col>
        <b-col cols="4">
          <div class="inner__style">
            <div v-if="imageSource.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
              <div>
                <i class="fas fa-cloud-upload-alt icon-size"></i>
                <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
              </div>
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div
                  v-for="(source, index) in imageSource"
                  :key="source"
                  class="uploaded-photo"
                  @click="setActiveImage(index)"
                  :class="activeImage === source ? 'activeImageClass' : ''"
                >
                  <div class="remove-icon" @click="removeImage(index)">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="source" />
                </div>
                <div @click="$bvModal.show('cropperModal')" class="uploaded-photo addNewImageIconContainer">
                  <i class="fa fa-plus"></i>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <template #modal-title>کراپ عکس</template>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
        </div>
      </b-modal>
      <b-modal id="errorModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../common/form/formModules/BaseText.vue'
import Price from '../common/form/formModules/Price.vue'
import Button from '../common/Button.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import ImageCropper from '../user/ImageCropper.vue'
import productDataProvider from '../../services/product'
import fileMannager from '../../services/file'
import Toast from '../common/Toast.vue'
export default {
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ImageCropper,
    Toast,
    Price,
    Button,
  },
  data() {
    return {
      cropperLoading: false,
      dommyNumber: 0,
      productId: '',
      guid: null,
      productPrice: '',
      productTitle: '',
      productNote: '',
      productIsActive: true,
      imageSource: [],
      activeImageIndex: null,
      activeImage: null,
      properties: [0],
      propertykeys: [],
      propertyValues: [],
      propertiesArray: [],
      showProductInput: true,
      showErrorToast: false,
      showImageToast: false,
      disableSubmit: false,
      productPriceError: false,
      productTitleError: false,
      productIdError: false,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'اضافه کردن کالای جدید',
          active: true,
        },
      ],
      title: 'اضافه کردن کالا',
      alertFlag: false,
    }
  },
  mounted() {
    if (this.$route.params.id) {
      const paramsId = this.$route.params.id
      productDataProvider.getProductDetail(paramsId).then((res) => {
        const productDetail = res.data.data.productData
        this.guid = productDetail.guid
        this.productId = productDetail.code
        this.productTitle = productDetail.name
        this.productPrice = this.changePriceValue(productDetail.stockItemsDto[0].price)
        this.productNote = productDetail.description
        this.productIsActive = productDetail.isAvailable
        this.imageSource = productDetail.imageUrls
        this.activeImage = productDetail.imageUrl
        productDetail.technicalPropertiesReadDb.map((e, index) => {
          if (index !== productDetail.technicalPropertiesReadDb.length - 1) {
            this.properties.push(this.dommyNumber++)
          }
          this.propertykeys.push(e.name)
          this.propertyValues.push(e.value)
        })
      })
    }
  },
  methods: {
    changePriceValue(payload) {
      let test = Number(payload).toLocaleString()
      return test
    },
    submit() {
      this.productIdError = false
      this.productTitleError = false
      this.productPriceError = false
      this.showImageToast = false
      if (this.productPrice.length === 0) {
        this.productPriceError = true
      }
      if (this.productTitle.length === 0) {
        this.productTitleError = true
      }
      if (this.productId.length === 0) {
        this.productIdError = true
      }
      if (this.imageSource.length === 0) {
        setTimeout(() => {
          this.showImageToast = true
        }, 100)
      } else {
        if (this.$route.params.id) {
          if (!this.productIdError && !this.productTitleError && !this.productPriceError) {
            this.disableSubmit = true
            this.propertiesArray = []
            for (let i = 0; i < this.properties.length; i++) {
              this.propertiesArray.push({
                name: this.propertykeys[i],
                value: this.propertyValues[i],
              })
            }
            const payloadPrice = this.productPrice.split(',').join('')
            productDataProvider
              .updateProduct({
                guid: this.guid,
                code: this.productId,
                name: this.productTitle,
                isAvailable: this.productIsActive,
                image: this.activeImage,
                imageUrls: this.imageSource,
                description: this.productNote,
                stocksItems: [
                  {
                    count: 1,
                    minCount: 0,
                    maxCount: 0,
                    price: payloadPrice,
                    discount: 0,
                    propItems: null,
                  },
                ],
                technicalPropertiesDto: this.propertiesArray,
              })
              .then((res) => {
                this.$router.push({ path: '/list/product' })

                this.disableSubmit = false
              })
              .catch(() => {
                this.disableSubmit = false
              })
          }
        } else {
          if (!this.productIdError && !this.productTitleError && !this.productPriceError) {
            this.disableSubmit = true
            this.propertiesArray = []
            for (let i = 0; i < this.properties.length; i++) {
              this.propertiesArray.push({
                name: this.propertykeys[i],
                value: this.propertyValues[i],
              })
            }
            const payloadPrice = this.productPrice.split(',').join('')
            productDataProvider
              .addMiniProduct({
                code: this.productId,
                name: this.productTitle,
                isAvailable: this.productIsActive,
                image: this.activeImage,
                imageUrls: this.imageSource,
                description: this.productNote,
                stocksItems: [
                  {
                    count: 1,
                    minCount: 0,
                    maxCount: 0,
                    price: payloadPrice,
                    discount: 0,
                    propItems: null,
                  },
                ],
                technicalPropertiesDto: this.propertiesArray,
              })
              .then((res) => {
                this.$router.push({ path: '/list/product' })

                this.disableSubmit = false
              })
              .catch(() => {
                this.disableSubmit = false
              })
          }
        }
      }
    },
    addNewPropertyField(i) {
      if (i === this.properties.length - 1) {
        this.properties.push(this.dommyNumber++)
      }
    },
    removePropertyField(payload) {
      this.dommyNumber--
      if (this.properties.length > 1) {
        this.properties.splice(payload, 1)
        this.propertyValues.splice(payload, 1)
        this.propertykeys.splice(payload, 1)
      }
    },
    addImageToListOfImages(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.cropperLoading = false

          this.imageSource.push(res.data.data.downloadUrl)
          this.$bvModal.hide('cropperModal')
        })
    },
    removeImage(payload) {
      this.imageSource.splice(payload, 1)
    },
    setActiveImage(payload) {
      this.activeImageIndex = payload
      this.activeImage = this.imageSource[payload]
    },
    cancelButton() {
      this.$router.go(-1)
    },
  },
  watch: {
    imageSourceLength(newValue) {
      if (newValue === 1) {
        this.activeImageIndex = 0
        this.activeImage = this.imageSource[0]
      }
    },
  },
  computed: {
    imageSourceLength() {
      return this.imageSource.length
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  background: #f8f8fb;
  border-radius: 8px;
}
.userInformation {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #556ee6;
}

.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px !important;
    color: white !important;
    background: #556ee6 !important;
    border-radius: 4px !important;
  }
  .cancelButton {
    padding: 6px 90px !important;
    margin-left: 12px !important;
    color: white !important;
    background: #74788d !important;
    border-radius: 4px !important;
  }
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.cancleButton {
  display: flex !important;
  margin-left: 10px !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: 14px !important;
  line-height: 23px !important;
  background: #74788d !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.deactiveUser {
  display: flex;
  align-items: center !important;
}
::v-deep .custom-control-label {
  margin-right: 5px;
}
.upload-photo-parent {
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 15px 15px;
  max-height: 410px;
  overflow-y: auto;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 3px !important;
  height: 100px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #eff2f7 !important;
  border-radius: 500px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 500px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(190, 190, 190) !important;
}
.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: center;
  display: flex;
  align-items: center;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}
.right__section {
  // background-color: white;
  height: 100%;
}
.left__section {
  background-color: transparent;
}
.inner__style {
  background-color: white;
  padding: 23px;
}
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  background: white;
  border: none;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 90px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
}
::v-deep .alert {
  padding: 0;
}
</style>
